import {createStore} from "vuex"
import createPersistedState from "vuex-persistedstate"
import content from "./content"
import kakaoMap from "./kakaoMap"
import notification from "./notification"
import region from "./region"
import sign from "./sign"

import router from "@/router"
import {setting} from '@/setting/index.js'
import searchbar from './searchbar'

export class UnauthorizedError extends Error {
    constructor(message = '사용시간이 만료되었습니다. 다시 로그인 해주시기 바랍니다.') {
        super(message);
        this.name = "UnauthorizedError";
    }
}

export default createStore({
    state: {
        officeId: undefined,
        api: {
            url: setting.url.vehicle,
            autoUrl: setting.url.login,
            tacho: setting.url.tacho,
            operationUrl: setting.url.operation
        },
        searchBar: searchbar.getInitialSearchBar(),
        message: {
            text: ""
        },
        isLoading: false
    },
    getters: {
        getApi(state) {
            return state.api;
        },
        getMessage(state) {
            return state.message;
        }
    },
    actions: {
        ...searchbar.actions,
    },
    mutations: {
        ...searchbar.mutations,
        openMessageBox(state, value) {
            if (value.response) {
                if (value.response.data.code === '1001_0000_013' || value.response.data.code === '1001_0000_001') {
                    value = new UnauthorizedError(value.response.data.message);
                } else {
                    if (value.response.data.message) {
                        state.message = {text: value.response.data.message}
                    } else {
                        state.message = {text: value.code}
                    }
                    return;
                }
            }

            if (value instanceof UnauthorizedError) {
                alert(value.message);
                state.sign.isSign = false;
                router.push('sign');
                return;
            }

            state.message = {text: value}
        },
        setLoading(state, value) {
            state.isLoading = value
        }
    },
    modules: {
        content: content,
        kakaoMap: kakaoMap,
        notification: notification,
        sign: sign,
        region: region,
    },
    plugins: [
        createPersistedState({
            paths: ["sign", "content", "region"]
        })
    ]
})
